import React from 'react';

export const ONBOARDING_TOAST_DURATION_MS = 4000;

/** Toast helpers for class components (call from constructor with `this`). */
export function bindOnboardingToastHandlers(component) {
  component.showOnboardingToast = (message) => {
    if (component.onboardingToastTimer) {
      clearTimeout(component.onboardingToastTimer);
    }
    component.setState({ toastMessage: message });
    component.onboardingToastTimer = setTimeout(() => {
      component.setState({ toastMessage: null });
      component.onboardingToastTimer = null;
    }, ONBOARDING_TOAST_DURATION_MS);
  };

  component.clearOnboardingToast = () => {
    if (component.onboardingToastTimer) {
      clearTimeout(component.onboardingToastTimer);
      component.onboardingToastTimer = null;
    }
    component.setState({ toastMessage: null });
  };
}

const OnboardingToast = ({ message }) => {
  if (!message) return null;

  return (
    <p className="onboarding-page__toast" role="alert">
      {message}
    </p>
  );
};

export default OnboardingToast;
